import { useAppSelector } from "~/ui-rtk/app/hooks"
import { selectUser } from "~/ui-rtk/app/selectors/user.selector"
import { useAuthControllerGetNovuHmacQuery } from "~/ui-rtk/api/authApi"

export function useNovuHmac() {
  const { id: userId } = useAppSelector(selectUser)

  return useAuthControllerGetNovuHmacQuery(undefined, {
    skip: !userId,
    refetchOnMountOrArgChange: 5 * 60, // 5 minutes
  })
}
